import styled from "styled-components";
import PropTypes from "prop-types";
const propTypes = {
  appearance: PropTypes.oneOf(["neat", "none", "round"])
};
const defaultProps = {
  appearance: "round"
};
const Dialog = styled("div")(
  ({ theme }) => ({
    backgroundColor: "white",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    maxHeight: "100%",
    overflow: "auto"
  }),
  ({ appearance }) => ({
    neat: {
      borderRadius: 2
    },
    none: {
      borderRadius: 0
    },
    round: {
      borderRadius: 4
    }
  })[appearance]
);
Dialog.propTypes = propTypes;
Dialog.defaultProps = defaultProps;
export {
  Dialog
};
